
import React from 'react';
import LandingDashboard from '../components/dashboard/LandingPage';

export default function LandingPage(props) {
    return <LandingDashboard {...props} />;
}
